import { render, staticRenderFns } from "./MealDetail.vue?vue&type=template&id=ee03074a&scoped=true&"
import script from "./MealDetail.vue?vue&type=script&lang=js&"
export * from "./MealDetail.vue?vue&type=script&lang=js&"
import style0 from "./MealDetail.vue?vue&type=style&index=0&id=ee03074a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee03074a",
  null
  
)

export default component.exports